exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#decline-artwork-dropzone[data-v-8c420c60]{min-height:126px}#decline-artwork-add-files[data-v-8c420c60]{padding-top:45px}.dz-uploaded-file[data-v-8c420c60]{cursor:default}", ""]);

// exports
